import { api, handleResponse } from "@/api/config";

export const authService = {
  login: async (data) => {
    const res = await api.post("/auth/login", data);
    return handleResponse(res);
  },

  getMe: async () => {
    const res = await api.get("/auth/me");
    return handleResponse(res);
  },

  validate: async () => {
    const res = await api.get("/auth/validate");
    return handleResponse(res);
  },

  refresh: async (data) => {
    const res = await api.post("/auth/refresh", data);
    return handleResponse(res);
  },

  resetPassword: async (token, password) => {
    const res = await api.post(`/auth/reset-password/${token}`, {
      password,
    });
    return handleResponse(res);
  },

  logout: async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.warn("Logout API failed:", err);
    }

    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("companyId");
    localStorage.removeItem("currentOrgId");

    return true;
  },

  getCurrentUser: async () => {
    return await authService.getMe();
  },

  isAuthenticated: () => {
    return !!localStorage.getItem("token");
  },

  validateToken: async () => {
    try {
      await authService.getMe();
      return true;
    } catch {
      return false;
    }
  },
};

export default authService;
